// extracted by mini-css-extract-plugin
module.exports = {"root":"Note_root__J2WTd","info":"Note_info__3SbZc","note":"Note_note__2VbjM","actions":"Note_actions__2tGzZ"};